var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import bootstrapCommonBase from '../../styles/bootstrap/base/common';
import { buttonStyle as bootstrapButtonStyle, buttonScript as bootstrapButtonScript, buttonUnscript as bootstrapButtonUnscript } from '../../styles/bootstrap/soul/button';
import { TiniElementTheming } from 'tinijs';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TiniElement, partAttrMap, borderToClassInfo, VaryGroups, } from 'tinijs';
export var ButtonModes;
(function (ButtonModes) {
    ButtonModes["Filled"] = "filled";
    ButtonModes["Outline"] = "outline";
    ButtonModes["Bordered"] = "bordered";
    ButtonModes["Clear"] = "clear";
})(ButtonModes || (ButtonModes = {}));
let TiniButtonComponent = class TiniButtonComponent extends TiniElement {
    static { this.defaultTagName = 'tini-button'; }
    static { this.componentName = 'button'; }
    /* eslint-enable prettier/prettier */
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        // root classes parts
        this.extendRootClasses({
            raw: {
                block: !!this.block,
                disabled: !!this.disabled,
                ...borderToClassInfo(this.border),
            },
            pseudo: {
                hover: {
                    [VaryGroups.Scheme]: this.hoverScheme,
                },
            },
            overridable: {
                [VaryGroups.Mode]: this.mode,
                [VaryGroups.Scheme]: this.scheme,
                [VaryGroups.Scale]: this.scale,
                [VaryGroups.Color]: this.color,
                [VaryGroups.FontSize]: this.fontSize,
                [VaryGroups.JustifyContent]: this.justifyContent,
                [VaryGroups.BorderRadius]: this.borderRadius,
                [VaryGroups.BoxShadow]: this.shadow,
            },
        });
    }
    render() {
        return html `<button
      class=${classMap(this.rootClasses)}
      part=${partAttrMap(this.rootClasses)}
      ?disabled=${this.disabled}
    >
      <slot></slot>
    </button>`;
    }
};
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "mode", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], TiniButtonComponent.prototype, "block", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], TiniButtonComponent.prototype, "disabled", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "scheme", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "scale", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "color", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "fontSize", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "justifyContent", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "border", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "borderRadius", void 0);
__decorate([
    property({ type: String, reflect: true })
], TiniButtonComponent.prototype, "shadow", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'hover:scheme' })
], TiniButtonComponent.prototype, "hoverScheme", void 0);
TiniButtonComponent = __decorate([
    TiniElementTheming({
        styling: { bootstrap: [bootstrapCommonBase, bootstrapButtonStyle] },
        scripting: { bootstrap: { script: bootstrapButtonScript, unscript: bootstrapButtonUnscript } },
    })
], TiniButtonComponent);
export { TiniButtonComponent };
//# sourceMappingURL=button.js.map